import * as React from "react";
import {API_URL, LINKEDIN_AUTHORIZATION_URL} from '../../../settings/local_settings';
import {AuthUrlLinkBase} from "./AuthUrlLinkBase";
import {LinkedinConnectButton} from "./LinkedinConnectButton";
import { withTranslation } from 'react-i18next';
import {setPendingLinkedinConnection} from "../connections/pendingLinkedinReconnect";

export class LinkedinLinkComponentClass extends AuthUrlLinkBase {

    _getAuthURL(){
        return LINKEDIN_AUTHORIZATION_URL;
    }

    _getDeleteUrl(){
        return API_URL + 'agency/linkedin-connection/delete/';
    }

    renderConnectionButton() {
        return <LinkedinConnectButton onClick={this.redirectToAuthPage} />;
    }

    renderDisconnectButton() {
        const { t } = this.props;
        return <button className="btn" onClick={this.deleteAgencyConnection}>{t('linkedin_link.disconnect_from_linkedin_ads')}</button>
    }


    redirectToAuthPage() {
        // Conexión NUEVA: se escribe la nota ENTERA (sin id, con el nombre tipeado en el modal si lo
        // hay), así nada de una reconexión abandonada se cuela y reemplaza otra conexión.
        setPendingLinkedinConnection({label: this.props.credentialLabel || null});
        window.location.href = this._getAuthURL();
    }
}

export const LinkedinLinkComponent = withTranslation()(LinkedinLinkComponentClass);
export default LinkedinLinkComponent;
